module.exports = __webpack_public_path__ + "static/media/uab.08f20f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uab.png
// module id = 283
// module chunks = 1